import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/share';

@Injectable()
export class InlineEditorService {

  public status: Subject<any> = new Subject<any>();
  private _value: any;

  constructor() { }

  public get value(): any {
    return this._value;
  }

  public set active(v: any) {
    this._value = v;
    this.status.next(v);
  }

  public setValue(value : any){
    this.active = value;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/inline-editor.service.ts